module.exports = __webpack_public_path__ + "static/media/get_it_on_google_play_button.e7b9ac64.png";